import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div className='footer-section'>
            <small>All Rights Reserved by My Footer</small>
        </div>
    );
};

export default Footer;